// Generated file : do not modify
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Liste des AEM
export class Aem {
  // Code du contrat
  public code: number;
  // Nom de l'établissement
  public etablissementNom: string;
  // Prénom du salarié
  public salariePrenom: string;
  // Nom du salarié
  public salarieNom: string;
  // Nom de l'emploi
  public emploiNom: string;
  // Numéro AEM
  public aemNumero: number;
  // Statut AEM
  public aemStatut: number;
  // Avis de dépôt AEM
  public aemDepot: number;
  // AEM date
  public aemDate: Date | null;

  constructor() {
    this.code = 0;
    this.etablissementNom = '';
    this.salariePrenom = '';
    this.salarieNom = '';
    this.emploiNom = '';
    this.aemNumero = 0;
    this.aemStatut = 0;
    this.aemDepot = 0;
    this.aemDate = null;
  }
}

export class AemQuery {
  // AEM statut
  public aemStatut: number;

  constructor() {
    this.aemStatut = 0;
  }
}

export class AemEdiExportError {
  // Numéro AEM
  public aemNumero: number;
  // Code du contrat
  public codeContrat: number;
  // Motif de l'échec
  public message: string;

  constructor() {
    this.aemNumero = 0;
    this.codeContrat = 0;
    this.message = '';
  }
}

export class AemEdiExportResult {
  // Contenu EDI encodé en Base64
  public content: string;
  // Nombre d'AEM exportées
  public successCount: number;
  // AEM non exportées
  public errors: AemEdiExportError[];

  constructor() {
    this.content = '';
    this.successCount = 0;
    this.errors = [];
  }
}

export default class AemList  {
  // ids
  public ids: number[];

  constructor() {
    this.ids = [];
  }

  public static fromJson (obj: AemList): AemList {
    const newAemList: AemList = new AemList();
    newAemList.ids = JSON.parse(JSON.stringify(obj.ids));
    return newAemList;
  }

  public toJsonAemList (): string {
    const json = {
      ids: this.ids,
    }
    return JSON.stringify(json);
  }

  public fromAemList (obj: AemList): void {
    this.ids = obj.ids;
  }

  public compareAemList (value: AemList): boolean {
    return (this.toJsonAemList() == value.toJsonAemList());
  }

  public cloneAemList (): AemList {
    return AemList.fromJson(this);
  }

  public static listAem (aemQuery: AemQuery): Promise<Aem[]> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/aemlists/listAem', aemQuery, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const cData: Aem[] = [];
              res.data.forEach(( a: Aem ) => {
                cData.push(a);
              })
              resolve(cData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static exportAemEdi (numerosAem: int[]): Promise<AemEdiExportResult> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/aemlists/exportAemEdi', numerosAem, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(aemLists: AemList[]) {
  }
}
